import { Base64 } from "js-base64";

import { environment } from "../config/environment";
import { clone, isServer } from "../../utils";
import { SlotParamsService } from "./SlotAppParamsService";

class AARPAuthService {
  public init() {
    if (!isServer) {
      this.updateLoginData();
    }
  }

  public getLoginUrl(): string {
    const url = this.buildBaseAuthLink();
    return url.href;
  }

  public getNewLoginUrl(isLoginFromMemberOnlyModal?: boolean): string {
    if (isLoginFromMemberOnlyModal) {
      const url = this.buildMemberOnlyRewardBaseLoginLink();
      return url.href;
    }
    const url = this.buildBaseLoginLink();
    return url.href;
  }

  public getPowerUpRedirectURL({ redirectType }: { redirectType: string }): string {
    const url = this.buildBaseLoginLinkFromPowerUps({redirectType}) 
    return url.href;
  }

  public getRegisterUrl(): string {
    const url = this.buildBaseRegisterLink();
    return url.href;
  }

  public buildBaseRegisterLink(returnUrl?: string): URL {
    const url = new URL(environment.AARP_REGISTER_BASE);
    url.searchParams.append("promo", "GAMESCUST");
    url.searchParams.append(
      "referrer",
      returnUrl ? returnUrl : window.location.href
    );
    return url;
  }

  public updateLoginData() {
    try {
      (window as any).AARP.Everywhere.LOGIN_DATA =
        this.buildCredentialsObject();
      (window as any).AARP.Everywhere.REGISTER_DATA =
        this.buildCredentialsObject();
    } catch (e) {
      console.error(e);
    }
  }

  public buildBaseLoginLink(returnUrl?: string): URL {
    const url = new URL(environment.AARP_LOGIN_BASE);
    url.searchParams.append(
      "referrer",
      returnUrl ? returnUrl : window.location.href
    );
    url.searchParams.append("promo", "GAMESCUST");
    url.searchParams.append("continueGame", "true");
    url.searchParams.append("action", "LOGIN");
    return url;
  }

  public buildBaseLoginLinkFromPowerUps({redirectType}: {redirectType: string}): URL {
    const data = redirectType === "login" 
      ? this.buildCredentialsObject() 
        : this.buildRegisterCredentialsObject();
    const url = new URL(data.baseUrl);

    url.searchParams.append("promo", "AARPREWARDS");
    url.searchParams.append("response_type", data.responseType);
    url.searchParams.append("client_id", data.clientId);
    url.searchParams.append("redirect_uri", data.redirectUri);
    url.searchParams.append("scope", data.scope);
    url.searchParams.append("state", data.state);
    url.searchParams.append("continueGame", "true");
    return url;
  }

  public buildMemberOnlyRewardBaseLoginLink(returnUrl?: string): URL {
    const url = new URL(environment.AARP_LOGIN_BASE);
    url.searchParams.append(
      "referrer",
      returnUrl ? returnUrl : window.location.href
    );
    url.searchParams.append("promo", "GAMESCUST");
    url.searchParams.append("continueGame", "true");
    url.searchParams.append("action", "REWARD_START");
    return url;
  }

  public buildBaseAuthLink(stateUrl?: string): URL {
    const data = this.buildCredentialsObject(stateUrl);
    const url = new URL(data.baseUrl);

    url.searchParams.append("response_type", data.responseType);
    url.searchParams.append("client_id", data.clientId);
    url.searchParams.append("redirect_uri", data.redirectUri);
    url.searchParams.append("scope", data.scope);
    url.searchParams.append("state", data.state);
    return url;
  }

  public buildMemberJoinLink(isRewardVideoModal?: boolean): URL {
    const url = new URL(environment.AARP_MEMBER_JOIN);
    url.searchParams.append("referrer", window.location.href);
    url.searchParams.append("offer", "games");
    url.searchParams.append("campaignid", "UJGMMOM");
    url.searchParams.append("promo", "GAMESCUST");
    if (isRewardVideoModal) {
      url.searchParams.append("continueGame", "true");
      url.searchParams.append("action", "REWARD_START");
    }
    return url;
  }

  private buildCredentialsObject(stateUrl: string = window.location.href) {
    const getRedirectURI = () => {
      if(environment.AARP_ENV === 'stage') {
        const url = new URL(window.location.href);
        const finalUrl = 'https://' + url.host + '/oauth2';
        return finalUrl;
      }
      return SlotParamsService.params.AARP_AUTH_REDIRECT;
    }
    
    return clone({
      baseUrl: environment.AARP_AUTH_BASE,
      responseType: "code",
      clientId: environment.AARP_AUTH_CLIENT_ID,
      redirectUri: getRedirectURI(),
      state: Base64.encodeURI(stateUrl),
      scope: "bui bmi em openid",
    });
  }

  private buildRegisterCredentialsObject(stateUrl: string = window.location.href) {
    const getRedirectURI = () => {
      if(environment.AARP_ENV === 'stage') {
        const url = new URL(window.location.href);
        const finalUrl = 'https://' + url.host + '/oauth2';
        return finalUrl;
      }
      return SlotParamsService.params.AARP_AUTH_REDIRECT;
    }
    
    return clone({
      baseUrl: environment.AARP_REGISTER_BASE,
      responseType: "code",
      clientId: environment.AARP_AUTH_CLIENT_ID,
      redirectUri: getRedirectURI(),
      state: Base64.encodeURI(stateUrl),
      scope: "bui bmi em openid",
    });
  }
}


export default new AARPAuthService();
